import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import WhatsAppCta from "./WhatsAppCta";

const FotoFaq = ({ faqs, whatsapp, location = "faq", compact = false }) => {
  const [open, setOpen] = useState(compact ? -1 : 0);
  if (!faqs?.length) return null;

  return (
    <section id="faq" className={`bg-white ${compact ? "py-12 md:py-16" : "py-20 md:py-28"}`}>
      <div className="container-page">
        <div className="mx-auto max-w-3xl">
          <h2 className={compact ? "font-display text-2xl font-bold tracking-tight text-navy-900" : "section-title"}>
            {compact ? "Dudas" : "Preguntas que llegan antes de contratar."}
          </h2>

          <div className={`${compact ? "mt-6" : "mt-12"} divide-y divide-navy-100 border-y border-navy-100`}>
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : index)}
                    className={`flex w-full items-center justify-between gap-4 text-left ${compact ? "py-3.5" : "py-5"}`}
                    aria-expanded={isOpen}
                  >
                    <span className={`${compact ? "text-base" : "text-lg"} font-semibold tracking-tight text-navy-900`}>
                      {item.q}
                    </span>
                    <ChevronDown
                      className={`h-5 w-5 shrink-0 text-navy-500 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      aria-hidden="true"
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.28, ease: "easeOut" }}
                        className="overflow-hidden"
                      >
                        <p className="pb-5 leading-relaxed text-navy-600">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>

          {whatsapp ? (
            <div className={compact ? "mt-6" : "mt-10"}>
              {compact ? null : <p className="text-navy-600">¿Otra duda?</p>}
              <WhatsAppCta message={whatsapp} location={location} variant="dark" className={compact ? "mt-0" : "mt-4"}>
                Preguntar por WhatsApp
              </WhatsAppCta>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default FotoFaq;
